import { Routes } from '@angular/router';
import { Home } from './home/home';
import { AddSource } from './components/source-view/add-source/add-source';
import { SearchSource } from './components/source-view/search-source/search-source';
import { Signin } from './components/sign-in/sign-in';
import { authGuard } from './guards/auth-guard';
import { transactionAccessGuard } from './guards/transaction-access.guard';
import { AddArticle } from './components/article-view/add-article/add-article';
import { SearchArticle } from './components/article-view/search-article/search-article';
import { ModelEditArticle } from './components/article-view/model-edit-article/model-edit-article';
import { ModelDeleteArticle } from './components/article-view/model-delete-article/model-delete-article';
import { SearchVariety } from './components/variety-view/search-variety/search-variety';
import { AddVariety } from './components/variety-view/add-variety/add-variety';
import { ModalEditVariety } from './components/variety-view/modal-edit-variety/modal-edit-variety';
import { ModalDeleteVariety } from './components/variety-view/modal-delete-variety/modal-delete-variety';
import { ModalDeleteSource } from './components/source-view/modal-delete-source/modal-delete-source';
import { ModalEditSource } from './components/source-view/modal-edit-source/modal-edit-source';
import { Buylicense } from './components/buylicense/buylicense';
import { AddProduct } from './components/product-view/add-product/add-product';
import { SearchProduct } from './components/product-view/search-product/search-product';
import { ModalEditProduct } from './components/product-view/modal-edit-product/modal-edit-product';
import { ModalDeleteProduct } from './components/product-view/modal-delete-product/modal-delete-product';
import { SourceFieldworkComponent } from './components/source-fieldwork/source-fieldwork';
import { AddArticleUp } from './components/article-view/add-article-up/add-article-up';
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';
import { ExportDataViewComponent } from './components/export-data-view/export-data-view';
import { IndicesReportComponent } from './components/indices-report/indices-report';
import { AtypicalPricesReportComponent } from './components/atypical-prices-report/atypical-prices-report';


export const routes: Routes = [
  {
    path: 'signin',
    component: Signin
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./components/forgot-password/forgot-password')
        .then(c => c.ForgotPasswordComponent)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: Home,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./components/profile/profile')
        .then(c => c.ProfileComponent),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'profile/change-password',
    loadComponent: () =>
      import('./components/change-password/change-password')
        .then(c => c.ChangePasswordComponent),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'acceso-denegado',
    loadComponent: () =>
      import('./components/access-denied/access-denied')
        .then((component) => component.AccessDeniedComponent),
    canActivate: [authGuard]
  },
  {
    path: 'add-source',
    component: AddSource,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'add-fountin',
    redirectTo: 'add-source',
    pathMatch: 'full'
  },
  {
    path: 'bitacora',
    loadComponent: () =>
      import('./components/bitacora/bitacora')
        .then(c => c.BitacoraComponent),
    canActivate: [authGuard, transactionAccessGuard]
  },

  {
    path: 'search-source',
    component: SearchSource,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'search-fountin',
    redirectTo: 'search-source',
    pathMatch: 'full'
  },
  {
    path: 'delete-source',
    component: ModalDeleteSource,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'delete-fountin',
    redirectTo: 'delete-source',
    pathMatch: 'full'
  },
  {
    path: 'edit-source',
    component: ModalEditSource,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'update-fountin',
    redirectTo: 'edit-source',
    pathMatch: 'full'
  },
  {
    path: 'add-article',
    component: AddArticle,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'add-article-up',
    component: AddArticleUp,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'search-article',
    component: SearchArticle,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'source-article',
    loadComponent: () =>
      import('./components/article-view/source-article/source-article')
        .then(c => c.SourceArticle),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'edit-article/:codigo',
    component: ModelEditArticle,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'delete-article/:codigo',
    component: ModelDeleteArticle,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'search-variety',
    component: SearchVariety,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'add-variety',
    component: AddVariety,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'edit-variety/:codigo',
    component: ModalEditVariety,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'delete-variety/:codigo',
    component: ModalDeleteVariety,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'source-fieldwork',
    component: SourceFieldworkComponent,
    canDeactivate: [UnsavedChangesGuard],
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'source-survey',
    redirectTo: 'source-fieldwork',
    pathMatch: 'full'
  },
  {
    path: 'fountains-outback',
    redirectTo: 'source-fieldwork',
    pathMatch: 'full'
  },
  {
    path: 'buylicense',
    component: Buylicense,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'variety/:codigo/articles',
    loadComponent: () =>
      import('./components/variety-view/variety-articles/variety-articles')
        .then(m => m.VarietyArticles),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'search-product',
    component: SearchProduct,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'export-data',
    component: ExportDataViewComponent,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'reportes/indices',
    component: IndicesReportComponent,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'reportes/variacion',
    component: IndicesReportComponent,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'reportes/incidencias',
    component: IndicesReportComponent,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'reportes/precios-atipicos',
    component: AtypicalPricesReportComponent,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'add-product',
    component: AddProduct,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'edit-product/:codigo',
    component: ModalEditProduct,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'delete-product/:codigo',
    component: ModalDeleteProduct,
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'product/:codigo/varieties',
    loadComponent: () => import('./components/product-view/product-class/product-class')
      .then(m => m.ProductClass),
    canActivate: [authGuard, transactionAccessGuard]

  },
  {
    path: 'calculos',
    loadComponent: () => import('./components/calculos-view/calculos-view/calculos-view')
      .then(c => c.CalculosViewComponent),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'calculos/consultar',
    loadComponent: () => import('./components/calculos-view/search-calculos/search-calculos')
      .then(c => c.SearchCalculosComponent),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'calculos/ejecutar',
    loadComponent: () => import('./components/calculos-view/ejecutar-calculo/ejecutar-calculo')
      .then(c => c.EjecutarCalculoComponent),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'consulta-boletas',
    loadChildren: () =>
      import('./features/ballot-query/routes').then(module => module.ballotQueryRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'ballot-editing',
    loadChildren: () => import('./components/ballot-editing/ballot.editing.routes'),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'ballot-capture',
    loadChildren: () =>
      import('./components/ballot-capture/ballot-capture.routes')
        .then(m => m.BALLOT_CAPTURE_ROUTES),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'revision-boletas',
    loadChildren: () =>
      import('./components/revision/revision.routes')
        .then(m => m.REVISION_ROUTES),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'fuentes-articulos',
    loadChildren: () => import('./features/source-articles/routes').then((module) => module.sourceArticleRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./features/user/routes').then((module) => module.userRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'transacciones',
    loadChildren: () => import('./features/transactions/routes').then((module) => module.transactionRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'transacciones-usuarios',
    loadChildren: () =>
      import('./features/user-transactions/routes').then((module) => module.userTransactionRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'actividades-empresa',
    loadChildren: () =>
      import('./features/business-activities/routes')
        .then((module) => module.businessActivityRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'tamanos-empresa',
    loadChildren: () =>
      import('./features/company-sizes/routes')
        .then((module) => module.companySizeRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'periodicidades-visita',
    loadChildren: () =>
      import('./features/visit-frequencies/routes')
        .then((module) => module.visitFrequencyRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'razones-nt',
    loadChildren: () =>
      import('./features/non-response-reasons/routes')
        .then((module) => module.nonResponseReasonRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'razones-variacion',
    loadChildren: () =>
      import('./features/variation-reasons/routes')
        .then((module) => module.variationReasonRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'caracteristicas',
    loadChildren: () =>
      import('./features/characteristics/routes')
        .then((module) => module.characteristicMaintenanceRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: 'unidades-medida',
    loadChildren: () =>
      import('./features/measurement-units/routes')
        .then((module) => module.measurementUnitRoutes),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {

    path: 'calculos/generar-boletas',
    loadComponent: () =>
      import('./components/calculos-view/generar-boletas/generar-boletas')
        .then(m => m.GenerarBoletasComponent),
    canActivate: [authGuard, transactionAccessGuard]
  },

  {


    path: 'calculos/generar-boletas',
    loadComponent: () =>
      import('./components/calculos-view/generar-boletas/generar-boletas')
        .then(m => m.GenerarBoletasComponent),
    canActivate: [authGuard, transactionAccessGuard]
  },
  {
    path: '**',
    redirectTo: 'signin'
  }
];
